module.exports = __webpack_public_path__ + "static/img/Frame861.dacf1cfd.png";